// Feature toggles loader with TTL caching in localStorage
// - Loads from cache if present and not expired
// - Otherwise calls backend command "GetPlatformFeatureFlagsQuery"
// - Writes fresh value to cache with TTL

import { postRequest } from "../api/requests/request";

export const FEATURE_TOGGLES_STORAGE_KEY = "__feature_toggles__";
const LOCALSTORAGE_TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

function nowMs() {
  return Date.now ? Date.now() : new Date().getTime();
}

export function readFeatureTogglesFromCache() {
  try {
    const raw = window.localStorage.getItem(FEATURE_TOGGLES_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw);

    if (!parsed || typeof parsed !== "object") return null;
    if (typeof parsed.expiresAt !== "number" || parsed.expiresAt <= nowMs()) {
      // expired
      window.localStorage.removeItem(FEATURE_TOGGLES_STORAGE_KEY);
      return null;
    }
    return Array.isArray(parsed.value) ? parsed.value : null;
  } catch (_) {
    return null;
  }
}

export function writeFeatureTogglesToCache(value, ttlMs = LOCALSTORAGE_TTL_MS) {
  // console.log("writeFeatureTogglesToCache", value, ttlMs);
  try {
    const payload = {
      value: Array.isArray(value) ? value : [],
      // store absolute expiry time
      expiresAt: nowMs() + Math.max(1000, Number(ttlMs || LOCALSTORAGE_TTL_MS)),
    };
    window.localStorage.setItem(
      FEATURE_TOGGLES_STORAGE_KEY,
      JSON.stringify(payload)
    );
  } catch (_) {
    // ignore storage errors
  }
}

export function clearFeatureTogglesCache() {
  try {
    window.localStorage.removeItem(FEATURE_TOGGLES_STORAGE_KEY);
  } catch (_) {
    // ignore
  }
}

async function fetchFeatureTogglesFromApi() {
  const response = await postRequest("GetPlatformFeatureFlagsQuery", {});
  // const response = await postRequest("GetConfigQuery", {
  //   configName: "Feature Flags Configuration",
  //   path: "admin_features",
  // });
  const data = response?.outData?.data;
  return data?.features;
}

export async function loadFeatureToggles({
  forceRefresh = false,
  ttlMs = LOCALSTORAGE_TTL_MS,
} = {}) {
  if (!forceRefresh) {
    const cached = readFeatureTogglesFromCache();
    if (cached) return cached;
  }
  const fresh = await fetchFeatureTogglesFromApi();
  //   filter out only features that are enabled
  const enabledFeatures = fresh.filter((f) => f?.isEnabled);

  writeFeatureTogglesToCache(enabledFeatures, ttlMs);
  return enabledFeatures;
}
